export const applyFavicon = (faviconUrl) => {
	const link = document.querySelector("link[rel~='icon']") ?? document.createElement("link");
	link.rel = "icon";
	link.href = faviconUrl;
	document.head.appendChild(link);
};
